import { render, staticRenderFns } from "./CostTwo.vue?vue&type=template&id=67142b61&scoped=true&"
import script from "./CostTwo.vue?vue&type=script&lang=js&"
export * from "./CostTwo.vue?vue&type=script&lang=js&"
import style0 from "./CostTwo.vue?vue&type=style&index=0&id=67142b61&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67142b61",
  null
  
)

export default component.exports